import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const communication_received = ({
  event: {
    kind, data: {
      sender,
      customer_answer,
    },
  },
}) =>
  <div className={kind}>
    Communication received from customer from number: {sender}.
    <br />
    Ready to schedule: {customer_answer}
  </div>;


communication_received.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      sender: PropTypes.string.isRequired,
      customer_answer: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/communication_received.jsx